// fixed the scroll when open/popup a global component

export function toggleScrollFixed(isOpen: boolean) {
  const headerBlock = document.querySelectorAll<HTMLDivElement>(
    ".container-header>.container-header-block"
  );
  const scrollBarWidth =
    window.innerWidth - document.documentElement.clientWidth;

  if (isOpen) {
    document.body.style.overflow = "hidden";
    if (scrollBarWidth <= 0) return;
    document.body.style.paddingRight = scrollBarWidth + "px";
    if (headerBlock) {
      headerBlock.forEach((item) => {
        item.style.paddingRight = scrollBarWidth + "px";
      });
    }
  } else {
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding");
    if (headerBlock) {
      headerBlock.forEach((item) => {
        item.style.paddingRight = scrollBarWidth + "px";
      });
    }
  }
}
